module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if( alignRightBI.contains(factoryKey)){ 
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Normal</div>\r\n    <div class=\"col-md-7\" style=\"padding: 0px; padding-left:10px\">\r\n        <input id=\"styleColorTextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleColorText ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleColorText\" name=\"styleColorText\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleColorText ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-4 prop-sublabel\">Over</div>\r\n    <div class=\"col-md-7\" style=\"padding: 0px; padding-left:10px\">\r\n        <input id=\"styleColorTextOverPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleColorTextOver ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleColorTextOver\" name=\"styleColorTextOver\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleColorTextOver ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Down</div>\r\n    <div class=\"col-md-7\" style=\"padding: 0px; padding-left:10px\">\r\n        <input id=\"styleColorTextDownPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleColorTextDown ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleColorTextDown\" name=\"styleColorTextDown\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleColorTextDown ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n")
    ;  }else{ 
    ; __append(" \r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Normal</div>\r\n    <div class=\"col-md-8\" style=\"padding-left: 10px\">\r\n        <input id=\"styleColorTextPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleColorText ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleColorText\" name=\"styleColorText\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleColorText ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\" style='")
    ; __append(escapeFn( mobileDesignerStyle ))
    ; __append("'>\r\n    <div class=\"col-md-4 prop-sublabel\">Over</div>\r\n    <div class=\"col-md-8\" style=\"padding-left: 10px\">\r\n        <input id=\"styleColorTextOverPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleColorTextOver ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleColorTextOver\" name=\"styleColorTextOver\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleColorTextOver ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel\">Down</div>\r\n    <div class=\"col-md-8\" style=\"padding-left: 10px\">\r\n        <input id=\"styleColorTextDownPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( styleColorTextDown ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"styleColorTextDown\" name=\"styleColorTextDown\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( styleColorTextDown ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n")
    ;  } 
    ; __append("  \r\n")
  }
  return __output;

}